<template>
    <master-page>
        <br/>
        <v-card>
            <v-card-title>
              <v-icon large left>mdi-cash-plus</v-icon>
              <span class="title font-weight-light">Recebíveis</span>
              <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="Novo()">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>Novo Recebível</span>
                  </v-tooltip>

                  <v-tooltip bottom v-if="tipoUsuario == 'GESTOR' ? false : PermissaoRestrita('GeracaoRecebiveis')">
                    <template v-slot:activator="{ on }">
                      <v-btn icon color="blue-grey lighten-1" class="mb-2" dark v-on="on">
                          <v-icon>mdi-plus-box-multiple-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Geração Recebível</span> <br/>
                    <span>Restrito ao seu usuário ou plano.</span>
                  </v-tooltip>   

                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on }">
                      <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="Gerar()">
                          <v-icon>mdi-plus-box-multiple-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Geração Recebível</span>
                  </v-tooltip>

                  <v-tooltip bottom v-if="!UsuarioRestrito(['G','B','P','E'])">
                    <template v-slot:activator="{ on }">
                      <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="Remessa()">
                        <v-icon>mdi-bank-transfer-in</v-icon>
                      </v-btn>
                    </template>
                    <span>Remessa Bancária</span>
                  </v-tooltip>

                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on }">
                      <v-btn icon color="blue-grey lighten-1" class="mb-2" dark v-on="on">
                        <v-icon>mdi-bank-transfer-in</v-icon>
                      </v-btn>
                    </template>
                    <span>Remessa Bancária</span> <br/>
                    <span>Restrito ao seu usuário ou plano.</span>
                  </v-tooltip>

                  <v-tooltip bottom v-if=" tipoUsuario == 'GESTOR' ? UsuarioRestrito(['G','B','P','E']) : UsuarioRestrito(['G','B','P','E']) || !PermissaoRestrita('RetornoBancario')">
                    <template v-slot:activator="{ on }">
                      <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="Retorno()">
                        <v-icon>mdi-bank-transfer-out</v-icon>
                      </v-btn>
                    </template>
                    <span>Retorno Bancário</span>
                  </v-tooltip>

                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on }">
                      <v-btn icon color="blue-grey lighten-1" class="mb-2" dark v-on="on">
                        <v-icon>mdi-bank-transfer-out</v-icon>
                      </v-btn>
                    </template>
                    <span>Retorno Bancário</span> <br/>
                    <span>Restrito ao seu usuário ou plano.</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="Imprimir()">
                          <v-icon>mdi-printer</v-icon>
                      </v-btn>
                    </template>
                    <span>Imprimir</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="Atualizar()">
                          <v-icon>mdi-refresh</v-icon>
                      </v-btn>
                    </template>
                    <span>Atualizar</span>
                  </v-tooltip>
              <v-expansion-panels focusable>
                <v-expansion-panel>
                <v-expansion-panel-header>Filtros</v-expansion-panel-header>
                  <v-expansion-panel-content class="mt-5">
                    <v-row>
                        <v-col cols="12" md="6">
                          <v-autocomplete v-model="filtro.doadorId" :items="doadores" :loading="isDoadorLoading" :search-input.sync="searchDoador" hide-no-data hide-selected cache-items clearable
                              item-text="cpfCnpjNome" item-value="id" label="Doador" placeholder="Digite um doador" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-autocomplete v-model="filtro.projetoId" :items="projetos" :loading="isProjetoLoading" :search-input.sync="searchProjeto" hide-no-data hide-selected cache-items clearable
                              item-text="codigoNome" item-value="id" label="Projeto" placeholder="Digite um projeto" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>

                    </v-row>
                    <v-row align="center">
                      <!-- DATA VENCIMENTO -->
                      <v-col cols="12" md="2">
                        <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                          <template v-slot:activator="{on}">
                            <v-text-field type="date" v-model="filtro.vencimentoInicial" label="Vencimento Inicial" dense outlined>
                              <template v-slot:prepend>
                                <v-icon v-on="on">mdi-calendar</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="filtro.vencimentoInicial" no-title/>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="1">
                        <span style="font-size: 18px; display: flex; justify-content: center; align-items: center; margin-top: -25px">até</span>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                          <template v-slot:activator="{on}">
                            <v-text-field type="date" v-model="filtro.vencimentoFinal" label="Vencimento Final" dense outlined>
                              <template v-slot:prepend>
                                <v-icon v-on="on">mdi-calendar</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="filtro.vencimentoFinal" no-title/>
                        </v-menu>
                      </v-col>
                      
                      <v-col cols="12" md="2"/>
                      
                      <!-- DATA PAGAMENTO -->
                      <v-col cols="12" md="2">
                        <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                          <template v-slot:activator="{on}">
                            <v-text-field type="date" v-model="filtro.pagamentoInicial" label="Pagamento Inicial" dense outlined>
                              <template v-slot:prepend>
                                <v-icon v-on="on">mdi-calendar</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="filtro.pagamentoInicial" no-title/>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="1">
                        <span style="font-size: 18px; display: flex; justify-content: center; align-items: center; margin-top: -25px">até</span>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                          <template v-slot:activator="{on}">
                            <v-text-field type="date" v-model="filtro.pagamentoFinal" label="Pagamento Final" dense outlined>
                              <template v-slot:prepend>
                                <v-icon v-on="on">mdi-calendar</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="filtro.pagamentoFinal" no-title/>
                        </v-menu>
                      </v-col>
                      
                      <!-- EMISSAO -->
                      <v-col cols="12" md="2">
                        <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                          <template v-slot:activator="{on}">
                            <v-text-field type="date" v-model="filtro.emissaoInicial" label="Emissão Inicial" dense outlined>
                              <template v-slot:prepend>
                                <v-icon v-on="on">mdi-calendar</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="filtro.emissaoInicial" no-title/>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="1">
                        <span style="font-size: 18px; display: flex; justify-content: center; align-items: center; margin-top: -25px">até</span>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                          <template v-slot:activator="{on}">
                            <v-text-field type="date" v-model="filtro.emissaoFinal" label="Emissão Final" dense outlined>
                              <template v-slot:prepend>
                                <v-icon v-on="on">mdi-calendar</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="filtro.emissaoFinal" no-title/>
                        </v-menu>
                      </v-col>

                      <v-col cols="12" md="2"/>

                      <!-- COMPETENCIA -->
                      <v-col cols="12" md="2">
                        <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                          <template v-slot:activator="{on}">
                            <v-text-field type="date" v-model="filtro.competenciaInicial" label="Competência Inicial" dense outlined>
                              <template v-slot:prepend>
                                <v-icon v-on="on">mdi-calendar</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="filtro.competenciaInicial" no-title/>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="1">
                        <span style="font-size: 18px; display: flex; justify-content: center; align-items: center; margin-top: -25px">até</span>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                          <template v-slot:activator="{on}">
                            <v-text-field type="date" v-model="filtro.competenciaFinal" label="Competência Final" dense outlined>
                              <template v-slot:prepend>
                                <v-icon v-on="on">mdi-calendar</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="filtro.competenciaFinal" no-title/>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="4">
                          <v-select v-model="filtro.formaPagamentoId" label="Forma de Pagamento" :items="formaPagamentos" item-value="key" item-text="value" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-select v-model="filtro.bancoId" label="Banco" :items="bancos" item-value="id" item-text="nome" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-select v-model="filtro.pessoalId" label="Atendente do Doador" :items="atendentes" item-value="id" item-text="nome" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="3">
                          <v-select v-model="filtro.regiaoId" label="Região/Grupo do Doador" :items="regioes" item-value="id" item-text="nome" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-select v-model="filtro.situacao" label="Situação" :items="situacoes" item-value="key" item-text="value" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6" style="display: flex" class="pa-0">
                          <v-row class="pa-0" style="display: flex; align-items: flex-start; justify-content: center">
                            <v-col cols="12" sm="4" md="5">
                              <v-text-field label="Código (Inicio)" v-model="filtro.codigoInicio" dense outlined hide-details/>
                            </v-col>
                            <v-col cols="12" md="2" class="body-1" align="center" style="margin-top: 6px">
                              até
                            </v-col>
                            <v-col cols="12" sm="4" md="5">
                              <v-text-field label="Código (Inicio)" v-model="filtro.codigoFim" dense outlined hide-details/>
                            </v-col>
                          </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                      <v-spacer></v-spacer>
                      <v-btn color="accent" @click="Atualizar()">Consultar</v-btn>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-title>

            <v-card-text>
                <div class="cards-totalizadores-container mb-4">
                  <v-card v-for="card in cardsTotalizadores" :key="card.chave" class="pa-3 totalizador-card" outlined :style="`background-color: ${card.corFundo}; border-color: ${card.corBorda};`">
                    <div class="d-flex">
                      <v-avatar size="28" :color="card.corIconeFundo" class="mr-3">
                        <v-icon small :color="card.corIcone">{{ card.icone }}</v-icon>
                      </v-avatar>
                      <div>
                        <div class="totalizador-titulo">{{ card.titulo }}</div>
                        <div class="totalizador-valor">{{ card.valor }}</div>
                        <div class="totalizador-subtitulo">{{ card.subtitulo }}</div>
                      </div>
                    </div>
                  </v-card>
                </div>

              <!-- :sort-by="['dataVencimento']" :sort-desc="[true]" 
              :footer-props="{ showFirstLastPage: true, 'items-per-page-options': [5, 10,15, 30, 50, 100, -1] }"
              -->

                <v-data-table id="tabela" :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1"
                  v-model="selectedItems" show-select>
            
                  <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
                    <v-checkbox hide-details class="mt-0" :value="isSelected" @change="select($event)" @input="select($event)" :disabled="item.isRemessaGerada" />
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">

                    <v-tooltip right v-if="item.situacao !== 'P' && item.situacao !== 'C'">
                      <template v-slot:activator="{ on }">
                        <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>

                    <v-tooltip right v-if="item.situacao !== 'C' && item.situacao !== 'P'">
                      <template v-slot:activator="{ on }">
                        <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                      </template>
                      <span>Excluir</span>
                    </v-tooltip>

                    <v-tooltip right v-if="item.situacao === 'A'">
                      <template v-slot:activator="{ on }">
                        <v-icon small @click="Cancelar(item)" v-on="on">mdi-close-circle</v-icon>
                      </template>
                      <span>Cancelar</span>
                    </v-tooltip>

                    <v-tooltip right v-if="PermissaoRestrita('BaixaRecebiveis')">
                      <template v-slot:activator="{ on }">
                        <v-icon small v-on="on" color="blue-grey lighten-1">mdi-chevron-down-circle</v-icon>
                      </template>
                      <span>Baixar</span> <br/>
                      <span>Restrito ao seu usuário ou plano.</span>
                    </v-tooltip>   

                    <v-tooltip right v-else-if="item.situacao === 'A'">
                      <template v-slot:activator="{ on }">
                        <v-icon small @click="Baixar(item)" v-on="on">mdi-chevron-down-circle</v-icon>
                      </template>
                      <span>Baixar</span>
                    </v-tooltip>  

                    <!-- <v-tooltip right v-if="item.situacao === 'A'">
                      <template v-slot:activator="{ on }">
                        <v-icon small @click="Baixar(item)" v-on="on">mdi-chevron-down-circle</v-icon>
                      </template>
                      <span>Baixar</span>
                    </v-tooltip> -->

                    <v-tooltip right v-if="item.situacao === 'A'">
                      <template v-slot:activator="{ on }">
                        <v-icon small @click="ImprimirBoleto(item)" v-on="on">mdi-printer</v-icon>
                      </template>
                      <span>Imprimir Boleto</span>
                    </v-tooltip>

                    <v-tooltip right v-if="item.situacao === 'P'">
                      <template v-slot:activator="{ on }">
                        <v-icon small @click="Reabrir(item)" v-on="on">mdi-lock-open</v-icon>
                      </template>
                      <span>Reabrir</span>
                    </v-tooltip>

                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon small @click="Consultar(item)" v-on="on">mdi-binoculars</v-icon>
                      </template>
                      <span>Consultar</span>
                    </v-tooltip>

                  </template>

                  <template v-slot:[`item.situacao`]="{ item }">
                    <v-chip :style=" item.situacao === 'A' ? 'background: var(--v-chipYellow-base) !important' : item.situacao === 'P' ? 'background: var(--v-chipGreen-base) !important' : 'background: var(--v-chipRed-base) !important'">
                      <span style="font-weight: bold" :style=" item.situacao === 'A' ? 'color: var(--v-chipFontYellow-base) !important' : item.situacao === 'P' ? 'color: var(--v-chipFontGreen-base) !important' : 'color: var(--v-chipFontRed-base) !important'">
                        {{item.situacao === "A" ? "Aberto" : item.situacao === "P" ? "Pago" : "Cancelado"}}
                      </span>
                    </v-chip>
                  </template>

                  <template v-slot:[`item.dataVencimento`]="{ item }">
                    {{new Date(item.dataVencimento).ddmmyyyy()}}
                  </template>

                  <template v-slot:[`item.dataPagamento`]="{ item }">
                    {{ item.dataPagamento ? new Date(item.dataPagamento).ddmmyyyy() : ''}}
                  </template>

                  <template v-slot:[`item.valor`]="{ item }">
                    {{item.valor.toMoeda()}}
                  </template>

                  <template v-slot:[`item.desconto`]="{ item }">
                    {{item.desconto.toMoeda()}}
                  </template>

                  <template v-slot:[`item.juros`]="{ item }">
                    {{item.juros.toMoeda()}}
                  </template>

                  <template v-slot:[`item.valorFinal`]="{ item }">
                    {{item.valorFinal.toMoeda()}}
                  </template>

                  <template v-slot:[`item.dataGeracaoRemessa`]="{ item }">
                    {{ item.dataGeracaoRemessa ? new Date(item.dataGeracaoRemessa).ddmmyyyy() : ''}}
                  </template>

                </v-data-table>

                <!-- <v-data-table :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1" 
                  v-model="selectedItems" show-select>
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr v-for="item in items" :key="item.id" >
                        <td>
                            <v-checkbox v-model="selectedItems" :value="item" dense :disabled="item.isRemessaGerada"/>
                        </td>
                        <td style="flex-wrap: nowrap; display: flex; height: 63px" >

                          <v-tooltip right>
                            <template v-slot:activator="{ on }">
                              <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                            </template>
                            <span>Editar</span>
                          </v-tooltip>
                          <v-tooltip right>
                            <template v-slot:activator="{ on }">
                              <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                            </template>
                            <span>Excluir</span>
                          </v-tooltip>
                          <v-tooltip right v-if="item.situacao === 'A'">
                            <template v-slot:activator="{ on }">
                              <v-icon small @click="Cancelar(item)" v-on="on">mdi-close-circle</v-icon>
                            </template>
                            <span>Cancelar</span>
                          </v-tooltip>

                          <v-tooltip right v-if="PermissaoRestrita('BaixaRecebiveis')">
                            <template v-slot:activator="{ on }">
                              <v-icon small v-on="on" color="blue-grey lighten-1">mdi-chevron-down-circle</v-icon>
                            </template>
                            <span>Baixar</span> <br/>
                            <span>Restrito ao seu usuário ou plano.</span>
                          </v-tooltip>   

                          <v-tooltip right v-else-if="item.situacao === 'A'">
                            <template v-slot:activator="{ on }">
                              <v-icon small @click="Baixar(item)" v-on="on">mdi-chevron-down-circle</v-icon>
                            </template>
                            <span>Baixar</span>
                          </v-tooltip>  

                          <v-tooltip right v-if="item.situacao === 'A'">
                            <template v-slot:activator="{ on }">
                              <v-icon small @click="Baixar(item)" v-on="on">mdi-chevron-down-circle</v-icon>
                            </template>
                            <span>Baixar</span>
                          </v-tooltip>


                          <v-tooltip right v-if="item.situacao === 'A'">
                            <template v-slot:activator="{ on }">
                              <v-icon small @click="ImprimirBoleto(item)" v-on="on">mdi-printer</v-icon>
                            </template>
                            <span>Imprimir Boleto</span>
                          </v-tooltip>
                          <v-tooltip right v-if="item.situacao === 'P'">
                            <template v-slot:activator="{ on }">
                              <v-icon small @click="Reabrir(item)" v-on="on">mdi-lock-open</v-icon>
                            </template>
                            <span>Reabrir</span>
                          </v-tooltip>
                        </td>
                        <td>{{ item.id }}</td>
                        <td>{{ item.doador.nome }}</td>
                        <td>{{ item.situacao }}</td>
                        <td>{{ new Date(item.dataVencimento).ddmmyyyy() }}</td>
                        <td>{{ item.dataPagamento ? new Date(item.dataPagamento).ddmmyyyy() : '' }}</td>
                        <td>{{ item.valor.toMoeda() }}</td>
                        <td>{{ item.desconto.toMoeda() }}</td>
                        <td>{{ item.juros.toMoeda() }}</td>
                        <td>{{ item.valorFinal.toMoeda() }}</td>
                        <td>{{ item.descricao }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table> -->

            </v-card-text>
        </v-card>
        
        <cadastro-recebivel v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Atualizar()" :baixa="baixa"/>
        <gerar-recebivel v-model="dialogGerar" :item="itemGerar" @fechou="dialogGerar = false" @salvou="Atualizar()"/>
        <retorno-recebivel v-model="dialogRetorno" :item="itemRetorno" @fechou="dialogRetorno = false" @salvou="Atualizar()"/>
          
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

    </master-page>
</template>

<script>
import RecebivelService from '@/core/services/financeiro/RecebivelService';
import Recebivel from '@/core/domain/financeiro/Recebivel';
import DoadorService from '@/core/services/doacao/DoadorService';
import ProjetoService from '@/core/services/projetos/ProjetoService';
import PessoalService from '@/core/services/projetos/PessoalService';
import RegiaoService from '@/core/services/doacao/RegiaoService';
import SituacaoFormaPagamentoService from '@/core/services/financeiro/SituacaoFormaPagamentoService';
import FormaPagamentoEnumService from '@/core/services/financeiro/FormaPagamentoEnumService';
import BancoService from '@/core/services/financeiro/BancoService';
import BoletoService from '@/core/services/financeiro/BoletoService';
import { EmpresaService } from '@/core/services/geral';
import UsuarioService from '../../../core/services/geral/UsuarioService';

const totalizadoresPadrao = () => ({
  totalRecebiveis: 0,
  totalRecebiveisAbertos: 0,
  totalRecebiveisPagos: 0,
  totalRecebiveisCancelados: 0,
  valorTotalRecebiveisAbertos: 0,
  valorTotalRecebiveisPagos: 0
});

export default {
  data() {
    return {
      service: new RecebivelService(),
      item: new Recebivel(),
      boletoService: new BoletoService(),
      overlay: true,
      itemGerar: {},
      itemRetorno: {},
      baixa: false,
      totalLista: 0,
      lista: [],
      selectedItems: [],
      dialogCadastro: false,
      dialogGerar: false,
      dialogRetorno: false,
      loading: false,
      loadingTotalizadores: false,
      options: {
        itemsPerPage: 15
      },
      headers: [
        { text: '', value:'actions', sortable: false  },
        { text: 'Código', value: 'id', type: 'number' },
        { text: 'Doador', value: 'doador.nome' },
        { text: 'Sit.', value: 'situacao' },
        { text: 'Vencimento', value: 'dataVencimento', type: 'date' },
        { text: 'Pagamento', value: 'dataPagamento', type: 'date' },
        { text: 'Valor', value: 'valor', type: 'number' },
        { text: 'Desc', value: 'desconto', type: 'number' },
        { text: 'Juros', value: 'juros', type: 'number' },
        { text: 'Total', value: 'valorFinal', type: 'number' },
        { text: 'Projeto', value: 'projetoId', type: 'number' },
        { text: 'Descrição', value: 'descricao'},
        { text: 'Remessa Gerada', value: 'dataGeracaoRemessa'},
      ],
      search: '',
      isDoadorLoading: false,
      isProjetoLoading: false,
      atendentes: [],
      situacoes: [],
      regioes: [],
      doadores: [],
      projetos: [],
      bancos: [],
      formaPagamentos: [],
      searchDoador: null,
      searchProjeto: null,
      filtro: {
        formaPagamentoId: null,
        bancoId: null,
        doadorId: null,
        projetoId: null,
        regiaoId: null,
        pessoalId: null,
        vencimentoInicial: '',
        vencimentoFinal: '',
        pagamentoInicial: '',
        pagamentoFinal: '',
        emissaoInicial: '',
        emissaoFinal: '',
        competenciaInicial: '',
        competenciaFinal: '',
        situacao: 'A',
        codigoInicio: null,
        codigoFim: null
      },
      empresaPlano: '',
      tipoUsuario: '',
      permissoes: [],
      totalizadores: totalizadoresPadrao()
    }
  },
  computed: {
    cardsTotalizadores(){
      return [
        {
          chave: 'total-recebiveis',
          titulo: 'Total de recebíveis',
          valor: this.loadingTotalizadores ? '-' : this.totalizadores.totalRecebiveis,
          subtitulo: 'Todos os recebíveis',
          icone: 'mdi-cash-plus',
          corFundo: '#eef2f7',
          corBorda: '#d7dee8',
          corIconeFundo: '#dce5f3',
          corIcone: '#4d6385'
        },
        {
          chave: 'total-recebiveis-abertos',
          titulo: 'Recebíveis abertos',
          valor: this.loadingTotalizadores ? '-' : this.totalizadores.totalRecebiveisAbertos,
          subtitulo: 'Quantidade',
          icone: 'mdi-folder-open-outline',
          corFundo: '#edf5f1',
          corBorda: '#d4e5dc',
          corIconeFundo: '#ddeee4',
          corIcone: '#4d7a64'
        },
        {
          chave: 'total-recebiveis-pagos',
          titulo: 'Recebíveis pagos',
          valor: this.loadingTotalizadores ? '-' : this.totalizadores.totalRecebiveisPagos,
          subtitulo: 'Quantidade',
          icone: 'mdi-check-circle-outline',
          corFundo: '#f5f1e8',
          corBorda: '#e7dcc7',
          corIconeFundo: '#efe6d4',
          corIcone: '#8a6c31'
        },
        {
          chave: 'total-recebiveis-cancelados',
          titulo: 'Recebíveis cancelados',
          valor: this.loadingTotalizadores ? '-' : this.totalizadores.totalRecebiveisCancelados,
          subtitulo: 'Quantidade',
          icone: 'mdi-close-circle-outline',
          corFundo: '#f2f2f8',
          corBorda: '#ddddea',
          corIconeFundo: '#e9e8f5',
          corIcone: '#6b678a'
        },
        {
          chave: 'valor-total-recebiveis-abertos',
          titulo: 'Recebíveis abertos',
          valor: this.loadingTotalizadores ? '-' : Number(this.totalizadores.valorTotalRecebiveisAbertos || 0).toMoeda(true),
          subtitulo: 'Valor total',
          icone: 'mdi-cash-clock',
          corFundo: '#f2eff5',
          corBorda: '#e2d9ea',
          corIconeFundo: '#e9def0',
          corIcone: '#71507f'
        },
        {
          chave: 'valor-total-recebiveis-pagos',
          titulo: 'Recebíveis pagos',
          valor: this.loadingTotalizadores ? '-' : Number(this.totalizadores.valorTotalRecebiveisPagos || 0).toMoeda(true),
          subtitulo: 'Valor total',
          icone: 'mdi-currency-usd-circle-outline',
          corFundo: '#f8f0f0',
          corBorda: '#ecdada',
          corIconeFundo: '#f3e1e1',
          corIcone: '#8a4d4d'
        }
      ];
    }
  },
  watch: {
    options: {
      handler () {
        this.Atualizar();
      },
      deep: true
    },
      searchDoador (val) {
          if (this.isDoadorLoading) return;
          if (!val) return;
          
          this.isDoadorLoading = true
          let doadorService = new DoadorService();
          doadorService.AutoComplete(val)
              .then(
                  res => {
                      this.doadores = res.data;
                  },
                  err => this.$swal('Aviso', err.response.data, 'error')
              )
              .finally(() => (this.isDoadorLoading = false))
      },
      searchProjeto (val) {
          if (this.isProjetoLoading) return;
          if (!val) return;
          
          this.isProjetoLoading = true
          let projetoService = new ProjetoService();
          projetoService.AutoComplete(val)
              .then(
                  res => {
                      this.projetos = res.data;
                  },
                  err => this.$swal('Aviso', err.response.data, 'error')
              )
              .finally(() => (this.isProjetoLoading = false))
      },
    lista: function(){
      if(this.overlay)
        this.overlay = false;
    }
  },
  methods: {
      Novo(){
        this.item = new Recebivel()
        this.dialogCadastro = true;
        this.baixa = false;
      },
      Remessa(){
        if (!this.filtro.vencimentoInicial || !this.filtro.vencimentoFinal ||
            this.filtro.formaPagamentoId == null || !this.filtro.bancoId){
          this.$swal('Aviso', 
          '<div style="text-align: left;">'+
            'Para prosseguir, é obrigatório informar nos filtros:'+
            '<br>-Vencimento Inicial <br>-Vencimento Final <br>-Forma de Pagamento <br>-Banco'+
          '</div>',
          'info');
          return;
        }

        if (this.selectedItems.length == 0) {
          this.$swal('Aviso', 'Selecione pelo menos um recebível!','info');
          return;
        }

        let validacao = true;
        this.selectedItems.forEach(recebivel => {

          // let dataVencimento = new Date(Date.UTC(new Date(recebivel.dataVencimento).getUTCFullYear(), new Date(recebivel.dataVencimento).getUTCMonth(), new Date(recebivel.dataVencimento).getUTCDay()));
          // let vencimentoInicial = new Date(Date.UTC(new Date(this.filtro.vencimentoInicial).getUTCFullYear(), new Date(this.filtro.vencimentoInicial).getUTCMonth(), new Date(this.filtro.vencimentoInicial).getUTCDay()));
          // let vencimentoFinal = new Date(Date.UTC(new Date(this.filtro.vencimentoFinal).getUTCFullYear(), new Date(this.filtro.vencimentoFinal).getUTCMonth(), new Date(this.filtro.vencimentoFinal).getUTCDay()));

          // console.log(`Vencimento: ${dataVencimento}`);
          // console.log(`Inicial: ${vencimentoInicial}`);
          // console.log(`Final: ${vencimentoFinal}`);

          // console.log(`Part 1: ${dataVencimento < vencimentoInicial}`);
          // console.log(`Part 2: ${dataVencimento > vencimentoFinal}`);

          // if(dataVencimento < vencimentoInicial || dataVencimento > vencimentoFinal){
          //   this.$swal('Aviso', 'Existem recebiveis fora do período de vencimento do filtro!','warning');
          //   console.log('chegou aqui')
          //   validacao = false;
          //   return;
          // }

          if(recebivel.bancoId != this.filtro.bancoId){
            this.$swal('Aviso', 'Existem recebiveis com banco diferente do filtro!','warning');
            validacao = false;
            return;
          }

          if(recebivel.formaPagamento != this.filtro.formaPagamentoId){
            this.$swal('Aviso', 'Existem recebiveis com forma de pagamento diferente do filtro!','warning');
            validacao = false;
            return;
          }
          
          if(!recebivel.doador.municipio && (!recebivel.doador.cidade || !(recebivel.doador.cidade.length > 0))){
            this.$swal('Aviso', `O doador: ${recebivel.doador.id} - ${recebivel.doador.nome} está com o campo "Município" em branco.`,'warning');
            validacao = false;
            return;
          }          
        });

        if (!validacao){
          return;
        }

        this.boletoService.GerarRemessa(this.selectedItems).then(
          res => {
            this.service.AtualizaRemessa(this.selectedItems).then(res2 => {
              let file = new Blob([res.data], {type: 'application/octet-stream'});
              let fileURL = URL.createObjectURL(file);
              const today = new Date();
              let fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.download = `CB${String(today.getMonth() + 1).padStart(2, '0')}${today.getFullYear()}A1.rem`;
              fileLink.click();
              this.Atualizar();
            });
          },
          err => {
            if (err.response){
              let decodedString = String.fromCharCode.apply(null, new Uint8Array(err.response.data));
              let erro = JSON.parse(decodedString);
              this.$swal('Aviso', erro.Message, 'error');
            }
            else {
              this.$swal('Aviso', err.message, 'error');
            }
          }
        );
      },
      Gerar(){
        this.itemGerar = {
          mesAnoInicial: '',
          mesAnoFinal: '',
          bancoId: 0
        };
        this.dialogGerar = true;
      },
      Retorno(){
        this.itemRetorno = {
          bancoId: 0
        };
        this.dialogRetorno = true;
      },
      Atualizar(){
        this.loading = true;
        this.loadingTotalizadores = true;
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;

        this.service.ListarComFiltro(page, itemsPerPage, sortBy, sortDesc, this.search, this.headers, this.filtro, "Doador.Municipio, Banco").then(
          res => {
            this.lista = res.data.items; 
            this.totalLista = res.data.count;
            this.selectedItems = [];
          },
          err => {
            this.$swal('Aviso', err.response.data, 'error')
          }
        ).finally(() => {
          this.loading = false;
        });

        this.service.TotalizadoresComFiltro(this.search, this.headers, this.filtro, "Doador.Municipio, Banco").then(
          res => {
            this.totalizadores = res.data;
          },
          err => {
            this.totalizadores = totalizadoresPadrao();
            this.$swal('Aviso', err.response.data, 'error')
          }
        ).finally(() => {
          this.loadingTotalizadores = false;
        });
      },
      Editar(item){
        this.service.ObterPorId(item.id, "Banco, Doador, Projeto")
          .then(
            res =>{
              this.item = Object.assign({}, new Recebivel(res.data))
              this.dialogCadastro = true;
              this.baixa = false;
            },
            err => this.$swal('Aviso', err.response.data, 'error')
          )
      },
      Excluir(item) {
        this.$swal({
          title: 'Atenção!',
          text: 'Tem certeza que deseja excluir o registro atual?',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          showCloseButton: true,
          showLoaderOnConfirm: true,
          preConfirm: () => {
              return this.service.Excluir(item.id)
                      .then(res => {
                          if (res.status == 200){
                              return res;
                          }
                      }, 
                      err => this.$swal('Aviso', err.response.data, 'error')
                  )
              },
          allowOutsideClick: () => !this.$swal.isLoading()
          })
          .then((result) => {
              if(result.value) {
                  this.$swal('Aviso', result.value.data, result.value.status == 200 ? 'success' : 'warning');
                  this.Atualizar();
              }
          })

      },
      Imprimir(){
        // let routeLink = this.$router.resolve({ name: 'imprimeRecebivel', params: { id: id.toString() } });
        // window.open(routeLink.href, '_blank');
        //let routeLink = this.$router.resolve({ name: 'imprimeRecebivel' });
        let routeLink = this.$router.resolve({ name: 'imprimeRecebivel', 
          query: { 
            bancoId: this.filtro.bancoId,
            formaPagamentoId: this.filtro.formaPagamentoId,
            doadorId: this.filtro.doadorId,
            projetoId: this.filtro.projetoId,
            regiaoId: this.filtro.regiaoId,
            pessoalId: this.filtro.pessoalId,
            vencimentoInicial: this.filtro.vencimentoInicial,
            vencimentoFinal: this.filtro.vencimentoFinal,
            pagamentoInicial: this.filtro.pagamentoInicial,
            pagamentoFinal: this.filtro.pagamentoFinal,
            emissaoInicial: this.filtro.emissaoInicial,
            emissaoFinal: this.filtro.emissaoFinal,
            competenciaInicial: this.filtro.competenciaInicial,
            competenciaFinal: this.filtro.competenciaFinal,
            situacao: this.filtro.situacao,
            codigoInicial: this.filtro.codigoInicio,
            codigoFinal: this.filtro.codigoFim
          } 
        });

        window.open(routeLink.href, '_blank');
      },
      Baixar(item){
        this.service.ObterPorId(item.id, "Banco, Doador, Projeto").then(
          res =>{
            this.item = Object.assign({}, new Recebivel(res.data))
            this.dialogCadastro = true;
            this.baixa = true;
          },
          err => this.$swal('Aviso', err.response.data, 'error')
        )
        // this.item = Object.assign({}, new Recebivel(item))
        // this.dialogCadastro = true;
        // this.baixa = true;
      },
      Cancelar(item) {
        this.$swal({
          title: 'Atenção!',
          text: 'Tem certeza que deseja cancelar o registro atual?',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          showCloseButton: true,
          showLoaderOnConfirm: true,
          preConfirm: () => {
              return this.service.Cancelar(item.id)
                      .then(res => {
                          if (res.status == 200){
                              return res;
                          }
                      }, 
                      err => this.$swal('Aviso', err.response.data, 'error')
                  )
              },
          allowOutsideClick: () => !this.$swal.isLoading()
          })
          .then((result) => {
              if(result.value) {
                  this.$swal('Aviso', result.value.data, result.value.status == 200 ? 'success' : 'warning');
                  this.Atualizar();
              }
          })

      },
      Reabrir(item) {
        this.$swal({
          title: 'Atenção!',
          text: 'Tem certeza que deseja Reabrir o registro atual?',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          showCloseButton: true,
          showLoaderOnConfirm: true,
          preConfirm: () => {
              return this.service.Reabrir(item.id)
                      .then(res => {
                          if (res.status == 200){
                              return res;
                          }
                      }, 
                      err => this.$swal('Aviso', err.response.data, 'error')
                  )
              },
          allowOutsideClick: () => !this.$swal.isLoading()
          })
          .then((result) => {
              if(result.value) {
                  this.$swal('Aviso', result.value.data, result.value.status == 200 ? 'success' : 'warning');
                  this.Atualizar();
              }
          })

      },
      ImprimirBoleto(item){
        this.overlay = true;

        this.item = Object.assign({}, new Recebivel(item));

        //this.boletoService.ImprimirPdf(this.item).then(
        this.service.BoletoPdf(this.item.id).then(
          res => {
            let file = new Blob([res.data], {type: 'application/pdf'});
            let fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          },
          err => {

            let decodedString = String.fromCharCode.apply(null, new Uint8Array(err.response.data));
            let erro = JSON.parse(decodedString);

            this.$swal('Aviso', erro.Message, 'error');
          }
        )
        .finally(() => {
          this.overlay = false;
        });

      },
      UsuarioRestrito(plano){
        if(this.tipoUsuario == "MASTER"){
          return false;
        }
        if(plano.find(x => x == this.empresaPlano)){
          return true;
        }
        else{
          return false;
        }
      },
      PermissaoRestrita(permissao){
        if(this.tipoUsuario == "MASTER"){
          return false;
        }
        if(this.permissoes.find(x => x.menu == permissao)){
          return false;
        }
        else{
          return true;
        }
      },
      Consultar(item){
        let routeLink = this.$router.resolve({ name: 'detalharRecebivel', params: { id: item.id.toString() } });
        window.open(routeLink.href, '_blank');
      }
    },
    created(){
      this.sessionApp = JSON.parse(localStorage.sessionApp);

      const usuarioService = new UsuarioService();
      usuarioService.ListarTudo("Permissoes").then(
        res=>{
          var usuario = res.data.items;
          usuario = usuario.find(x => x.id == this.sessionApp.usuarioId)
          this.permissoes = usuario.permissoes;
        }
      )
    },
    mounted() {

      this.sessionApp = JSON.parse(localStorage.sessionApp); 
      this.empresaPlano = this.sessionApp.plano
      this.tipoUsuario = this.sessionApp.usuarioNome;

      let situacaoFormaPagamentoService = new SituacaoFormaPagamentoService();
      situacaoFormaPagamentoService.Listar()
        .then(
            res => {
                this.situacoes = res.data;
                this.situacoes.unshift({
                  key: null,
                  value: 'TODOS'
                });
            },
            err => {
                this.$swal('Aviso', err.message, 'error');
            }
        );

      let regiaoService = new RegiaoService();
      regiaoService.Listar()
        .then(
            res => {
                this.regioes = res.data.items;
                this.regioes.unshift({
                  id: null,
                  nome: 'TODOS'
                });
            },
            err => {
                this.$swal('Aviso', err.message, 'error');
            }
        );

      let pessoalService = new PessoalService();
      pessoalService.ObterComUsuario()
        .then(
            res => {
                this.atendentes = res.data;
                this.atendentes.unshift({
                  id: null,
                  nome: 'TODOS'
                });
            },
            err => {
                this.$swal('Aviso', err.message, 'error');
            }
        );

      let bancoService = new BancoService();
      bancoService.Listar()
        .then(
            res => {
                this.bancos = res.data.items;
                this.bancos.unshift({
                  id: null,
                  nome: 'TODOS'
                });
            },
            err => {
                this.$swal('Aviso', err.message, 'error');
            }
        );

      let formaPagamentoEnumService = new FormaPagamentoEnumService();
      formaPagamentoEnumService.Listar()
        .then(
            res => {
                this.formaPagamentos = res.data;
                this.formaPagamentos.unshift({
                  key: null,
                  value: 'TODOS'
                });
            },
            err => {
                this.$swal('Aviso', err.message, 'error');
            }
        );

    }
}
</script>
<style scoped>
.totalizador-card {
  border-width: 1px;
  border-style: solid;
  min-height: 90px;
  width: 100%;
}

.cards-totalizadores-container {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: clamp(8px, 0.8vw, 14px);
}

@media (max-width: 1400px) {
  .cards-totalizadores-container {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 960px) {
  .cards-totalizadores-container {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .cards-totalizadores-container {
    grid-template-columns: 1fr;
  }
}

.totalizador-titulo {
  font-size: 10px;
  color: #5f6a77;
  font-weight: 600;
  line-height: 1.2;
}

.totalizador-valor {
  font-size: 20px;
  font-weight: 700;
  color: #202b37;
  line-height: 1.1;
}

.totalizador-subtitulo {
  font-size: 10px;
  color: #6b7280;
  margin-top: 2px;
}

</style>
